import React, { useState } from "react";
import { Link, useLocation } from 'react-router-dom';
import './TopBar.css';

const TopBar = ({ isVisible }) => {
  const location = useLocation();
  const [showNotifications, setShowNotifications] = useState(false);
  const currentUser = JSON.parse(localStorage.getItem('user'));

  const isActive = (path) => location.pathname === path;

  return (
    <div className={`topbar-wrapper ${!isVisible ? '' : ''}`}>
      <div className="topbar-container">
        <div className="topbar-content">
          {/* Logo Section */}
          <div className="topbar-logo">
            <Link to="/">
              <img src="/images/homehive.png" alt="HomeHive" className="logo" />
            </Link>
          </div>

          {/* Main Navigation */}
          <div className="topbar-nav">
            <Link to="/" className={`nav-item ${isActive('/') ? 'active' : ''}`}>
              <i className="fas fa-home"></i>
              <span className="nav-label">For you</span>
            </Link>
            
            <Link to="/properties" className={`nav-item ${isActive('/properties') ? 'active' : ''}`}>
              <i className="fas fa-building"></i>
              <span className="nav-label">All Properties</span>
            </Link>

            {currentUser && (
              <Link to="/conversations" className={`nav-item ${isActive('/conversations') ? 'active' : ''}`}>
                <i className="fas fa-comments"></i>
                <span className="nav-label">Messages</span>
              </Link>
            )}
          </div>

          {/* Right Section */}
          <div className="topbar-right">
            {currentUser ? (
              <>
                <div className="auth-buttons">
                <Link to="/logout" className="login-btn">Logout</Link>
              </div>
                {/* User Menu */}
                <div className="user-menu">
                  {currentUser && currentUser.user ? (
                    <>
                    <Link to={currentUser.user.is_landlord ? "/landlord/dashboard" : "/my-profile"} className="user-profile">
                      <img 
                        src={currentUser.user.avatar ? currentUser.user.avatar : "/images/profile.png"}
                        alt="Profile" 
                        className="avatar"
                      />
                      <span className="username">{currentUser.user.name}</span>
                    </Link>
                    </>
                  ) : (
                    <Link to="/profile" className="user-profile">
                      <img 
                        src="/images/profile.png"
                        alt="Profile" 
                        className="avatar"
                      />
                      <span className="username">Guest</span>
                    </Link>
                  )}
                </div>
              </>
            ) : (
              <div className="auth-buttons">
                <Link to="/login" className="login-btn">Login</Link>
                <Link to="/signup" className="signup-btn">Sign Up</Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
